import * as TypeGraphQL from "type-graphql";
export var ABTestRecommendation;
(function (ABTestRecommendation) {
    ABTestRecommendation["PROMOTE_TREATMENT"] = "PROMOTE_TREATMENT";
    ABTestRecommendation["KEEP_CONTROL"] = "KEEP_CONTROL";
    ABTestRecommendation["INCONCLUSIVE"] = "INCONCLUSIVE";
})(ABTestRecommendation || (ABTestRecommendation = {}));
TypeGraphQL.registerEnumType(ABTestRecommendation, {
    name: "ABTestRecommendation",
    description: undefined,
});
//# sourceMappingURL=ABTestRecommendation.js.map